import React from 'react';
import step1 from '../../../icons/feed-step-1.svg';
import step2 from '../../../icons/feed-step-2.svg';
import step3 from '../../../icons/feed-step-3.svg';
import step4 from '../../../icons/feed-step-4.svg';
import step5 from '../../../icons/feed-step-5.svg';
import step6 from '../../../icons/feed-step-6.svg';

const STEP_IMAGES = [step1, step2, step3, step4, step5, step6];

const StepIcon = ({ index }) => (
    <img
        className="feedlab-step-icon"
        src={STEP_IMAGES[index]}
        alt={`Этап ${index + 1}`}
    />
);

const StepIcons = STEP_IMAGES.map((_, i) => {
    const Component = () => <StepIcon index={i} />;
    Component.displayName = `StepIcon${i + 1}`;
    return Component;
});

export default StepIcons;
